const initialState = {};

export default (state = initialState, action)=>{
    switch(action.type){
        case 'SET_USER':
            return state
        default:
            return state
    }
}